import styled from '@emotion/styled';

export const StyledParticipant = styled.div`
	grid-area: ${(props) => (props.isPinned ? "pinned_participant" : '')};
`;
